export default "__VITE_ASSET__WTwFssFd__"